module.exports = __webpack_public_path__ + "static/media/logo.82aa62b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/blog-logo/logo.png
// module id = 400
// module chunks = 0